import _ from 'lodash';

const updateSystemFilter = (systemFilterOptions, existingSF, field, value, checked) => {
  const newSystemFilter = _.cloneDeep(existingSF);

  if (field === 'uId' && checked) {
    newSystemFilter.thermostatZone = newSystemFilter.thermostatZone.filter(f => f.uId !== value);
  } else if (field === 'uId' && !checked) {
    const hvac = systemFilterOptions.find(sf => sf.uId === value);
    let tZones;
    if (hvac) {
      tZones = hvac.thermostatZones.map(tz => tz.serialNumber);
    }
    newSystemFilter.thermostatZone.push({
      uId: value,
      tZoneSN: tZones,
    });
  } else if (field === 'tZoneSN' && checked) {
    const cUid = value.split('-')[0];
    newSystemFilter.thermostatZone = newSystemFilter.thermostatZone.map((sf) => {
      if (sf.uId === cUid) {
        sf.tZoneSN = sf.tZoneSN.filter(sn => sn !== value);
      }
      return sf;
    });
    newSystemFilter.thermostatZone = newSystemFilter.thermostatZone.filter(sf => sf.tZoneSN.length);
  } else if (field === 'tZoneSN' && !checked) {
    const cUid = value.split('-')[0];
    const uIdFound = newSystemFilter.thermostatZone.find(u => u.uId === cUid);
    if (uIdFound) {
      newSystemFilter.thermostatZone = newSystemFilter.thermostatZone.map((sf) => {
        if (sf.uId === cUid) {
          sf.tZoneSN.push(value);
        }
        return sf;
      });
    } else {
      newSystemFilter.thermostatZone.push({
        uId: cUid,
        tZoneSN: [value],
      });
    }
  } else if (field === 'cycleTypeFilter' && checked) {
    newSystemFilter.cycleTypeFilter = newSystemFilter.cycleTypeFilter.filter(ct => ct !== value);
  } else if (field === 'cycleTypeFilter' && !checked) {
    newSystemFilter.cycleTypeFilter.push(value);
  } else if (field === 'deltaTFilter' && checked) {
    newSystemFilter.deltaTFilter = newSystemFilter.deltaTFilter.filter(ct => ct !== value);
  } else if (field === 'deltaTFilter' && !checked) {
    newSystemFilter.deltaTFilter.push(value);
  } else if (field === 'alertCategoryFilter' && checked) {
    newSystemFilter.alertCategoryFilter = newSystemFilter.alertCategoryFilter.filter(ct => ct !== value);
  } else if (field === 'alertCategoryFilter' && !checked) {
    newSystemFilter.alertCategoryFilter.push(value);
  } else if (field === 'dateFilter' && value) {
    newSystemFilter.dateFilter = value;
    newSystemFilter.dateRange.start = '';
    newSystemFilter.dateRange.end = '';
  } else if (field === 'dateRange' && value) {
    const {
      start,
      end,
    } = value;
    newSystemFilter.dateRange.start = start;
    newSystemFilter.dateRange.end = end;
    newSystemFilter.dateFilter = '';
  } else if (field === 'singleThermostatZone') {
    newSystemFilter.singleTZone = value;
  } else if (field === 'allTZoneSelected') {
    newSystemFilter.thermostatZone = [];
    newSystemFilter.allTZoneSelected = value;
  }

  newSystemFilter.allTZoneSelected = newSystemFilter.thermostatZone.length === 0;

  return newSystemFilter;
};

export default updateSystemFilter;
